var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("loading", {
        attrs: { active: _vm.isLoading, "is-full-page": true },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _c("list-paymentRequest", {
        attrs: { listPaymentRequest: _vm.listPaymentRequest }
      }),
      _c(
        "div",
        [
          _c("paging", {
            attrs: {
              intTotal: _vm.pageSettings.total,
              intCurrPage: _vm.pageSettings.pageIndex,
              intRowPerPage: _vm.pageSettings.rowPerPage,
              intPageSize: _vm.pageSettings.pageSize
            },
            on: {
              eventClickPage: function($event) {
                return _vm.onChangePage($event)
              }
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "paymentRequest-main-footer" }, [
        _c(
          "div",
          {
            staticClass: "page-footer",
            class: { ml0: !_vm.showMenu, ml220: _vm.showMenu }
          },
          [
            _c("div", { staticClass: "content" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-danger btn-block",
                  attrs: { href: "javascript: void(0)" },
                  on: { click: _vm.createNewPaymentRequest }
                },
                [_vm._v("Tạo yêu cầu")]
              )
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }